import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables throttle replacement for current debounce logic in quick add
 */
export const ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307 =
  'ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307' as SettingConst<
    'ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
